import { configureStore } from "@reduxjs/toolkit";
import userSlice from "./Slice/UserSlice";
import storeSlice from "./Slice/StoreSlice";
import MerchantsSlice from "./Slice/MerchantsSlice";
import organizationSlice from "./Slice/OrganizationSlice";


const store = configureStore({
    reducer: {
        user: userSlice,
        store:storeSlice,
        merchant:MerchantsSlice,
        organization: organizationSlice,
      },
});

export default store;